import React from "react";
import "./CartProduct.css";
import { useStateValue } from "../../StateProvider";

function CheckoutProduct({ product_id, productName, productImage, price }) {
  const [{ cart }] = useStateValue();
  const cartItem = cart.find((item) => item.id === product_id);
  const quantity = cartItem ? cartItem.quantity : 1;

  const total = new Intl.NumberFormat("en-NG", {
    style: "currency", currency: "NGN", minimumFractionDigits: 2,
  }).format(price * quantity);

  return (
    <div className="cop">
      <div className="cop__img-wrap">
        <img src={productImage} alt={productName} className="cop__img" />
        <span className="cop__qty">{quantity}</span>
      </div>
      <p className="cop__name">{productName}</p>
      <strong className="cop__price">{total}</strong>
    </div>
  );
}

export default CheckoutProduct;
